import { LeadPageType } from 'enums/leadPageTypes';
import { leadLazyLoad } from 'utils/loadable';

export const ResourcesPage = leadLazyLoad(
  () => import('./ResourcesPage'),
  module => module.ResourcesPage,
  { fallback: null, type: LeadPageType.RESOURCES },
);
